/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PostHeader from 'components/PostHeader';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import Image from 'components/common/Image';
import Button from 'components/common/Button';
import EmptyUserProfilePhoto from 'components/EmptyUserProfilePhoto/EmptyUserProfilePhoto';
import SocialActivity from 'components/SocialActivity';
import { useState } from 'react';
import { likePost, unlikePost } from 'services/likePost';
import {
  FeedPostWrapper,
  PostHeaderWrap,
  UserImageWrapper,
} from './RewardPointsEarnedPost.styles';

const RewardPointsEarnedPost = ({
  profilePhoto,
  userId,
  creatorId,
  username,
  fullname,
  isVerified,
  isAmbassador,
  isDonor,
  isMe,
  followingStatus,
  postTime,
  origin,
  id,
  originId,
  type,
  data,
  postData,
  onCommentClick,
}: any) => {
  const { t } = useTranslation();
  const router = useRouter();
  const rewardRequestDetails = postData?.rewardRequestDetails;
  const photo = rewardRequestDetails?.businessId?.profilePhoto;
  const { isLike, likes, commentsCount, sharesCount } = postData;

  const [postLike, setPostLike] = useState<boolean>(isLike);
  const [likesCount, setLikesCount] = useState<number>(likes || 0);
  const [isProfilePhotoUrlCopied, setIsProfilePhotoUrlCopied] =
    useState<boolean>(false);

  const onLikePost = (id) => {
    setPostLike(!postLike);
    if (postLike) {
      unlikePost(id).then((res) => {});
      setLikesCount(likesCount - 1);
      return;
    }
    likePost(id).then((res) => {});
    setLikesCount(likesCount + 1);
  };

  return (
    <FeedPostWrapper>
      <PostHeader
        profilePhoto={profilePhoto}
        userId={userId}
        username={username}
        fullname={fullname}
        creatorId={creatorId}
        isVerified={isVerified}
        isAmbassador={isAmbassador}
        isDonor={isDonor}
        isMe={isMe}
        followingStatus={followingStatus}
        postTime={postTime}
        type={type}
        id={id}
        origin={origin}
        originId={originId}
        data={data || postData}
        businessId={rewardRequestDetails?.businessId?._id}
      />

      <div style={{ float: 'left', padding: '3%' }}>
        <PostHeaderWrap>
          <UserImageWrapper>
            {photo ? (
              <Image
                src={photo.trim()}
                alt="author post img"
                width={48}
                height={48}
                unoptimized
                priority
              />
            ) : (
              <EmptyUserProfilePhoto
                wrapSize={48}
                userIconSize={24}
                cursor="pointer"
              />
            )}
          </UserImageWrapper>

          <b style={{ marginRight: '14px' }}>
            {rewardRequestDetails?.businessId?.name}
          </b>

          <Button
            style={{}}
            variant="default"
            outline
            size="sm"
            onClick={() =>
              router.push(`/b/${rewardRequestDetails?.businessId?._id}`)
            }
          >
            {t('feed:visit')}
          </Button>

          <div style={{ marginLeft: '45px' }}>
            {t('feed:pointsEarned')} : {rewardRequestDetails.claimRewardAmount}
          </div>
          <br />
          <br />
        </PostHeaderWrap>
      </div>
      <div style={{ clear: 'both' }}>
        <br />
      </div>

      <div>
        <SocialActivity
          id={id}
          originId={originId}
          onCommentClick={(id) => onCommentClick(id)}
          onLikeClick={(id) => onLikePost(id)}
          commentsNumber={commentsCount}
          sharesNumber={sharesCount}
          likesNumber={likesCount}
          isLike={postLike}
          postType={10}
          type="reward"
          isUrlCopied={isProfilePhotoUrlCopied}
          setIsUrlCopied={setIsProfilePhotoUrlCopied}
          businessId={rewardRequestDetails?.businessId?._id}
        />
      </div>
    </FeedPostWrapper>
  );
};

export default RewardPointsEarnedPost;
